// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"tj_a bic_b bic_bj","StrollerbaseBanner__hint":"tj_b bic_vh","StrollerbaseBanner__link":"tj_c"};